/**
 * @Description: 素材展示列表组件
 * @author zhaijiayu
 * @date 2021/8/25
*/
<template>
  <div class="material-list">
    <div
      class="material-item"
      v-for="(item, index) in materialList"
      :key="index"
    >
      <div class="source-container" v-if="item.cm_icon_url">
        <div class="imageContainer" @click="gotoDetail(item.cm_id)">
          <!-- <el-image
            class="image"
            fit="contain"
            :src="item.urlList[0]"
            :preview-src-list="item.urlList"
          /> -->
          <img class="image" :src="item.cm_icon_url" />
        </div>
      </div>
      <p class="title">
        {{ item.cm_title }}
      </p>
      <section class="footer">
        <span class="date">{{ item.cm_create_time }}</span>
        <action-bar
          :refresh-list="refreshList"
          :material-detail="item"
          :vertical="true"
        />
      </section>
    </div>
    <el-empty description="暂无内容" v-if="materialList.length === 0" />
  </div>
</template>
<script>
import { MATERIAL_AUDIT_STATUS } from "../../../constants/manuscript";
import actionBar from "./action-bar";
import ActionBar from "./action-bar";

export default {
  name: "materialList",
  props: {
    materialList: Array,
    refreshList: Function,
  },
  components: {
    ActionBar,
    MaterialActionBar: actionBar,
  },
  filters: {
    /**
     * 获取审核状态
     * @returns {string}
     */
    getCheck: function (check) {
      check = parseInt(check);
      return MATERIAL_AUDIT_STATUS[check];
    },
  },
  methods: {
    /**
     * 跳转素材详情
     * @param id 素材id
     */
    gotoDetail: function (id) {
      window.open(
        this.$router.resolve({
          name: "materialDetail",
          query: { materialId: id },
        }).href,
        "_blank"
      );
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../styles/variables";

.material-list {
  background: #ffffff;
  overflow: hidden;
  width: 100%;

  .material-item {
    width: calc((100% - 85px) / 6);
    //min-width: calc(188px + (17px * 5 / 6));
    margin-right: 17px;
    margin-bottom: 20px;
    float: left;

    .source-container {
      width: 100%;
      overflow: hidden;
      border-radius: 6px;
      background: $img-bg-color;
      display: flex;
      align-items: center;
      padding-top: 100%;
      position: relative;

      .imageContainer {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }

      .img {
        width: 100%;
      }
    }
    .title {
      margin-top: 13px;
      color: $text-color-main;
      font-size: 14px;
      font-weight: bold;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .footer {
      display: flex;
      margin-top: 8px;
      justify-content: space-between;

      .date {
        color: #999999;
      }
    }
  }
  .material-item:nth-child(6n) {
    margin-right: 0;
  }
}
</style>